export default {
    headText: 'Datenschutzerklärung',
    headSubtext: 'DREIklang GmbH Münster'
}
